<template>
    <p class="text-canvas-paragraph">
       <slot /> 
    </p>
</template>
<script>
export default {
    name: 'Paragraph'
}
</script>